import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "49",
  height: "48",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.8814 17.1158L24.1406 18.375L25.3999 17.1157C26.3944 16.1212 27.7432 15.5625 29.1497 15.5625C32.0786 15.5625 34.4531 17.9369 34.4529 20.8659C34.4529 22.2724 33.8942 23.6212 32.8997 24.6157L24.1406 33.375L15.3814 24.6157C14.3869 23.6212 13.8281 22.2724 13.8281 20.8657C13.8281 17.9369 16.2025 15.5625 19.1314 15.5625C20.538 15.5625 21.8869 16.1213 22.8814 17.1158Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.51562 24C3.51562 29.4701 5.68862 34.7162 9.55656 38.5841C13.4245 42.4521 18.6705 44.625 24.1406 44.625C29.6108 44.625 34.8568 42.4521 38.7248 38.5841C42.5927 34.7162 44.7656 29.4701 44.7656 24C44.7656 18.5299 42.5927 13.2839 38.7248 9.41593C34.8568 5.54799 29.6108 3.375 24.1406 3.375C18.6705 3.375 13.4245 5.54799 9.55656 9.41593C5.68862 13.2839 3.51562 18.5299 3.51562 24Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }